









import { Component, Vue } from 'vue-property-decorator';

const { version, name } = require('../../../package.json');

@Component
export default class Footer extends Vue {
  private version = version;

  private name = name;
}
